import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const VoucherService = {
  // Get all vouchers with filters
  getList: async (params = {}) => {
    try {
      const response = await instance.get("/accounting/vouchers", {
        params,
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching vouchers:", error);
      throw error;
    }
  },

  // Get a single voucher by ID
  getById: async (id) => {
    try {
      const response = await instance.get(`/accounting/vouchers/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching voucher ${id}:`, error);
      throw error;
    }
  },

  // Create a new voucher
  create: async (data) => {
    try {
      const response = await instance.post("/accounting/vouchers", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating voucher:", error);
      throw error;
    }
  },

  // Update an existing voucher
  update: async (id, data) => {
    try {
      const response = await instance.put(`/accounting/vouchers/${id}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating voucher ${id}:`, error);
      throw error;
    }
  },

  // Delete a voucher
  delete: async (id) => {
    try {
      const response = await instance.delete(`/accounting/vouchers/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting voucher ${id}:`, error);
      throw error;
    }
  },

  // Workflow Patches
  initiate: async (id) => {
    try {
      const response = await instance.patch(`/accounting/vouchers/${id}/initiate`, {}, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error initiating voucher ${id}:`, error);
      throw error;
    }
  },

  review: async (id) => {
    try {
      const response = await instance.patch(`/accounting/vouchers/${id}/review`, {}, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error reviewing voucher ${id}:`, error);
      throw error;
    }
  },

  approve: async (id) => {
    try {
      const response = await instance.patch(`/accounting/vouchers/${id}/approve`, {}, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error approving voucher ${id}:`, error);
      throw error;
    }
  },

  reject: async (id) => {
    try {
      const response = await instance.patch(`/accounting/vouchers/${id}/reject`, {}, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error rejecting voucher ${id}:`, error);
      throw error;
    }
  },
};

export default VoucherService;
